import React from 'react'
import dayjs from 'dayjs'
import { Divider, Link, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import IframeContent from './IframeContent'
import Attachments from './Attachments'

const EmailContent = ({ email }) => {
  if (!email) {
    return null
  }

  let body = email?.body || ''
  if (!/<(body|div|span).*>/i.test(body)) {
    body = `<div style="white-space: pre-line;">${body}</div>`
  }

  const styles = {
    root: {
      height: '100%',
      overflowY: 'hidden',
      flexGrow: 1,
    },
    header: {
      padding: '24px',
      display: 'flex',
      justifyContent: 'space-between'
    },
    attachments: {
      padding: '24px',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    receiver: {
      display: 'flex',
      alignItems: 'center'
    },
    content: {
      flexGrow: 1,
      padding: '48px 24px'
    },
    message: {
      fontFamily: "Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif",
    }
  }

  return (
    <div style={styles.root}>
      <div style={styles.header}>
        <div style={styles.receiver}>
          <div>
            <Typography
              display="inline"
              variant="h5"
            >
              {email.from?.name}
            </Typography>{' '}
            <Link
              color="textSecondary"
              display="inline"
              variant="body2"
            >
              {email.from?.email || '(Unknown)'}
            </Link>
            <Typography variant="subtitle2">
              To: <strong>{email.to && email.to.map(to => `${to.name}${to.email ? ` (${to.email})` : ''}`).join(', ')}</strong>
            </Typography>
            <Typography variant="subtitle2">
              Subject: <strong>{email.subject}</strong>
            </Typography>
            <Typography variant="body2">
              {dayjs(email.date).format('MMMM Do YYYY, h:mm:ss a')}
            </Typography>
          </div>
        </div>
      </div>
      <Divider />
      {email.attachments && email.attachments.length > 0 && (
        <>
          <Attachments attachments={email.attachments} />
          <Divider />
        </>
      )}
      <div style={styles.content}>
        {email.body !== undefined ? (
          <IframeContent body={body} />
        ) : (
          <CircularProgress size={14} />
        )}
      </div>
    </div>
  )
}

export default EmailContent
